import apiClient from '../client';

// Data Export API

/**
 * Export rewards data to CSV
 */
export async function exportRewardsData(params: {
  startDate?: Date;
  endDate?: Date;
}): Promise<string> {
  const response: any = await apiClient.post('/fidelity/export/rewards', {
    startDate: params.startDate?.toISOString(),
    endDate: params.endDate?.toISOString(),
  });
  return response.data;
}

/**
 * Export products data to CSV
 */
export async function exportProductData(params: {
  startDate?: Date;
  endDate?: Date;
}): Promise<string> {
  const response: any = await apiClient.post('/fidelity/export/products', {
    startDate: params.startDate?.toISOString(),
    endDate: params.endDate?.toISOString(),
  });
  return response.data;
}

/**
 * Export products scans data to CSV
 */
export async function exportProductsScansData(params: {
  startDate?: Date;
  endDate?: Date;
}): Promise<string> {
  const response: any = await apiClient.post('/fidelity/export/products-scans', {
    startDate: params.startDate?.toISOString(),
    endDate: params.endDate?.toISOString(),
  });
  return response.data;
}

/**
 * Export rewards claims data to CSV
 */
export async function exportRewardsClaimsData(params: {
  startDate?: Date;
  endDate?: Date;
}): Promise<string> {
  const response: any = await apiClient.post('/fidelity/export/rewards-claims', {
    startDate: params.startDate?.toISOString(),
    endDate: params.endDate?.toISOString(),
  });
  return response.data;
}
